import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './Icon';

/**
 * Back navigation button with chevron-left icon.
 * @param {function} onClick - custom handler (defaults to navigate(-1))
 * @param {'default'|'admin'} variant - 'admin' renders boxed hover style
 */
export default function BackButton({ onClick, variant = 'default' }) {
  const navigate = useNavigate();
  const handler = onClick || (() => navigate(-1));

  if (variant === 'admin') {
    return (
      <button onClick={handler} className="w-10 h-10 flex items-center justify-center hover:bg-mono-50 rounded-lg transition-colors">
        <Icon name="chevron-left" size={20} />
      </button>
    );
  }

  return (
    <button onClick={handler} className="text-mono-900 hover:text-orange-500 transition">
      <Icon name="chevron-left" size={24} />
    </button>
  );
}
